import React from 'react';
import Icon from './Icon';

/**
 * Admin page header icon box.
 * Dark rounded-xl container with white icon.
 */
export default function PageHeaderIcon({ icon }) {
  return (
    <div className="w-10 h-10 rounded-xl bg-mono-700 flex items-center justify-center">
      <Icon name={icon} size={24} className="text-white" />
    </div>
  );
}
